import { createStore, withProps } from "@ngneat/elf";
import { withRequestsStatus } from "@ngneat/elf-requests";

import { AffiliateDetailsModel } from "@store/entities/afiliates/details/affiliateDetails.model";

export const affiliateDetailsStore = createStore({ name: "affiliate-details" }, withProps<AffiliateDetailsModel>({}), withRequestsStatus());
